export class ValueItem {
    name: string;
    value: string;
    path: string;
}